import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import { MapPin, Store } from "lucide-react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

L.Icon.Default.mergeOptions({ iconUrl: markerIcon, iconRetinaUrl: markerIcon2x, shadowUrl: markerShadow });

export default function PublicDealers() {
  const [data, setData] = useState({ enabled: false, dealers: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/dealers/public").then((r) => setData(r.data)).catch(() => {}).finally(() => setLoading(false)); }, []);

  return (
    <div className="min-h-screen bg-background" data-testid="public-dealers-page">
      <header className="border-b border-border px-4 sm:px-6 py-4 flex flex-wrap gap-3 items-center justify-between">
        <Logo size={22} />
        <Button asChild variant="outline" size="sm"><Link to="/" data-testid="public-dealers-login">Accedi</Link></Button>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        <h1 className="font-head text-3xl font-bold tracking-tight">Trova un dealer Markoo Place</h1>
        <p className="text-sm text-muted-foreground mt-2">I punti vendita dove attivare SIM, eSIM, ricariche e servizi.</p>

        {loading && <p className="text-muted-foreground mt-8">Caricamento…</p>}

        {!loading && !data.enabled && (
          <Card className="p-10 mt-8 text-center glow-border" data-testid="map-disabled-notice">
            <Store className="w-10 h-10 text-muted-foreground mx-auto" />
            <p className="font-head text-lg font-semibold mt-4">Mappa non ancora disponibile</p>
            <p className="text-sm text-muted-foreground mt-1">La mappa dei dealer sarà pubblicata a breve. Torna presto!</p>
          </Card>
        )}

        {!loading && data.enabled && (
          <div className="grid lg:grid-cols-[1fr_360px] gap-6 mt-8">
            <div className="rounded-2xl overflow-hidden border border-border h-[min(60dvh,520px)]" data-testid="dealers-map">
              <MapContainer center={[41.9, 12.5]} zoom={6} style={{ height: "100%", width: "100%" }}>
                <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                {data.dealers.map((d) => (
                  <Marker key={d.id} position={[d.lat, d.lng]}>
                    <Popup>
                      <div className="text-sm">
                        <p className="font-semibold">{d.company_name || d.name}</p>
                        {d.address && <p>{d.address}</p>}
                        <Link to={`/dealers/${d.id}`} className="text-primary">Vedi profilo →</Link>
                      </div>
                    </Popup>
                  </Marker>
                ))}
              </MapContainer>
            </div>
            <div className="space-y-3 max-h-[520px] overflow-y-auto pr-1">
              {data.dealers.length === 0 && <p className="text-sm text-muted-foreground">Nessun dealer sulla mappa al momento.</p>}
              {data.dealers.map((d) => (
                <Link key={d.id} to={`/dealers/${d.id}`} data-testid={`dealer-list-item-${d.id}`}>
                  <Card className="block p-4 glow-border hover:border-primary/50 transition-colors">
                    <p className="font-semibold">{d.company_name || d.name}</p>
                    {d.address && <p className="text-xs text-muted-foreground flex items-center gap-1 mt-1"><MapPin className="w-3 h-3" /> {d.address}</p>}
                    {d.opening_hours && <p className="text-xs text-muted-foreground mt-1">{d.opening_hours}</p>}
                  </Card>
                </Link>
              ))}
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
